import orderBy from 'lodash/orderBy';
import lowerCase from 'lodash/lowerCase';

const sortPickerItemsAlphabetically = (pickerItems) =>
  orderBy(pickerItems, [({ label }) => lowerCase(label)]);

export default sortPickerItemsAlphabetically;
